
const userTempRegister = {
  // --- step one
  accessValid: false,
  passCreated: false,
};

export default userTempRegister;

